<app-dialog-header [title]="'Export Admin Timesheets'"></app-dialog-header>

<mat-dialog-content class="tw-flex tw-flex-col tw-gap-4">
    <div>
        <div class="tw-flex tw-items-start tw-space-x-8">
            <mat-radio-group
                [(ngModel)]="isDateRangeMode"
                (change)="dateTypeChange()"
            >
                <mat-radio-button class="tw-mr-1" [value]="false">
                    Week of
                </mat-radio-button>

                <mat-radio-button [value]="true">Date Range</mat-radio-button>
            </mat-radio-group>

            <div class="tw-mb-2">
                <form [formGroup]="dateRangeForm">
                    <mat-form-field *ngIf="isDateRangeMode">
                        <mat-label>Enter Session Period</mat-label>

                        <mat-date-range-input [rangePicker]="picker">
                            <input
                                matStartDate
                                matInput
                                placeholder="Start Date"
                                required
                                formControlName="startDate"
                                (dateChange)="dateChange($event)"
                            />
                            <input
                                matEndDate
                                matInput
                                placeholder="End Date"
                                required
                                formControlName="endDate"
                                (dateChange)="dateChange($event)"
                            />
                        </mat-date-range-input>
                        <mat-hint>MM/DD/YYYY - MM/DD/YYYY</mat-hint>

                        <mat-datepicker-toggle
                            matSuffix
                            [for]="picker"
                        ></mat-datepicker-toggle>
                        <mat-date-range-picker #picker></mat-date-range-picker>

                        <mat-error
                            *ngIf="
                                dateRangeForm.controls.startDate.hasError(
                                    'matStartDateInvalid'
                                )
                            "
                        >
                            Invalid start date
                        </mat-error>
                        <mat-error
                            *ngIf="
                                dateRangeForm.controls.endDate.hasError(
                                    'matEndDateInvalid'
                                )
                            "
                        >
                            Invalid end date
                        </mat-error>

                        <mat-error
                            *ngIf="
                                dateRangeForm.controls.startDate.errors
                                    ?.required
                            "
                        >
                            Start Date Required
                        </mat-error>
                        <mat-error
                            *ngIf="
                                dateRangeForm.controls.endDate.errors?.required
                            "
                        >
                            End Date Required
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="fill" *ngIf="!isDateRangeMode">
                        <mat-label>Select Week</mat-label>

                        <input
                            matInput
                            formControlName="date"
                            [matDatepicker]="picker"
                            (dateChange)="dateChange($event)"
                        />
                        <mat-hint>MM/DD/YYYY</mat-hint>
                        <mat-datepicker-toggle
                            matSuffix
                            [for]="picker"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                </form>
            </div>
        </div>

        <mat-divider></mat-divider>

        <div class="tw-flex tw-items-center tw-gap-16 tw-mt-4">
            <h3 class="tw-ml-3">Select Users To Export:</h3>

            <mat-form-field
                class="input-width"
                matTooltip="Maximum of three users per export"
                matTooltipPosition="right"
            >
                <input
                    matInput
                    placeholder="New User..."
                    name="currentName"
                    #userInput
                    [(ngModel)]="currentUser"
                    [matChipInputFor]="chipGrid"
                    [matAutocomplete]="auto"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    (matChipInputTokenEnd)="add($event)"
                    [disabled]="selectedAdminUsers().length >= maxExportUsers"
                />
            </mat-form-field>

            <mat-autocomplete
                #auto="matAutocomplete"
                [autoActiveFirstOption]="false"
                (optionSelected)="selected($event); userInput.value = ''"
            >
                @for (user of filteredAdminUsers(); track user) {
                    <mat-option [value]="user">
                        {{ user.name }}
                    </mat-option>
                }
            </mat-autocomplete>
        </div>

        <mat-chip-grid #chipGrid aria-label="Name selection" selectable="false">
            @if (selectedAdminUsers().length > 0) {
                <mat-card class="chip-background tw-ml-4 chip-scroll-wrapper">
                    @for (user of selectedAdminUsers(); track $index) {
                        <mat-chip-row class="tw-mt-2" (removed)="remove(user)">
                            {{ user.name }}

                            <button matChipRemove>
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </mat-chip-row>
                    }
                </mat-card>
            }
        </mat-chip-grid>
    </div>

    <mat-divider></mat-divider>

    <div class="tw-flex tw-flex-row tw-items-center tw-gap-4">
        <h3>Export Format:</h3>

        <mat-radio-group [formControl]="formatControl">
            <mat-radio-button [value]="PDF">PDF</mat-radio-button>

            <mat-radio-button [value]="CSV">CSV</mat-radio-button>
        </mat-radio-group>
    </div>
</mat-dialog-content>

<div class="tw-flex tw-justify-between tw-items-center tw-w-full">
    <button
        mat-button
        class="tw-w-[30%] tw-flex tw-m-3 tw-self-end m3-error"
        (click)="onExitClick()"
    >
        Cancel
    </button>

    <button
        mat-button
        class="tw-w-[30%] tw-flex tw-m-3 tw-self-end"
        [disabled]="
            !adminUserData() ||
            !formatControl.value ||
            selectedAdminUsers().length == 0
        "
        (click)="exportTimesheets(formatControl.value)"
    >
        Export
    </button>
</div>
